import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarClienteSimplificadoCompleto(api, parametros) {
    parametros.operacao = 'buscarClienteSimplificadoCompleto';

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCliente/RClienteBuscarClienteSimplificadoCompleto.js